import { ChipColor } from '@/components/chips/types';
import { projectItemListTransformer } from '@/features/projects/helpers';
import { ProjectItemList } from '@/features/projects/types';

import {
  getIconNamesFromOpportunity,
  getColorFromOpportunityStatus,
  getIconStatesFromOpportunity,
  getLocationFromOpportunityProjects,
  getTechnologyTypesFromOpportunityProjects,
  getDevelopmentStatusFromOpportunityProjects,
  getCapacityFromOpportunityProjects,
  getTotalMwFromOpportunityProjects,
  getCompanyTypeFromOpportunityProjects,
  getTypeOfRevenueFromOpportunityProjects,
} from '../helpers';
import { Opportunity, OpportunityItemList } from '../types';

export function opportunityItemListTransformer(opportunity: Opportunity): OpportunityItemList {
  const isOnlyOneProject = opportunity.projects.length === 1;
  const opportunityProjects = opportunity.projects.map((project, index) => ({
    name: project ? (project.name ?? (isOnlyOneProject ? 'Project' : `Project ${index + 1}`)) : '',
    details: project ? projectItemListTransformer(project.project) : ({} as ProjectItemList),
  }));
  const projects = opportunityProjects.map((project) => project.details);
  const isPaid = opportunity.type.toLowerCase() === 'paid';
  const totalViews = opportunity.opp_summary_stats?.filter((opp: any) => opp.key === 'view').length ?? 0;
  // const offers = (opportunity.offers ?? []).map((offer) => ({ id: offer.id, status: offer.status }));
  const offers = (opportunity.offers ?? []).map((offer) => ({
    id: offer.id,
    status: offer.status,
    updatedAt: offer.updated_at,
  }));

  return {
    id: opportunity.id,
    name: opportunity.name,
    company: opportunity.company,
    createdAt: opportunity.created_at,
    location: getLocationFromOpportunityProjects(projects),
    technologies: {
      types: getTechnologyTypesFromOpportunityProjects(projects),
      icons: {
        name: getIconNamesFromOpportunity(opportunity),
        states: getIconStatesFromOpportunity(opportunity),
      },
      state: {
        list: getDevelopmentStatusFromOpportunityProjects(projects),
      },
      capacity: getCapacityFromOpportunityProjects(projects),
    },
    status: {
      name: opportunity.status,
      color: getColorFromOpportunityStatus(opportunity.status) as ChipColor,
    },
    projects: opportunityProjects,
    isPublished: opportunity.status === 'published',
    isPaid: isPaid,
    hasPV: checkOpportunityHasPv(projects),
    offers: offers,
    options: opportunity?.options,
    closedType: opportunity?.closed_type,
    stats: {
      eoisReceived: opportunity.offers?.length ?? 0,
      opportunitiesViews: totalViews,
    },
    totalMw: getTotalMwFromOpportunityProjects(opportunity.projects) ?? undefined,
    companyType: getCompanyTypeFromOpportunityProjects(opportunity.projects),
    typeOfRevenue: getTypeOfRevenueFromOpportunityProjects(opportunity.projects),
  };
}

export function checkOpportunityHasPv(projects: ProjectItemList[]) {
  return projects.some((project) => project.technologies.types.includes('solar'));
}
